import * as actionType from "./assetsAction";
import { ApiGateWay } from "../../../ApiGateWay/ApiGateWay";
import { Config } from "../../../config/config";
import Cookie from "js-cookie";
import LZString from "lz-string";
const config = JSON.parse(Config);
const apiInterface = config["api1"];
const apiInterface4 = config["api4"];
const initialState = {
  message: "",
  modalOpen: false,
  loading: false,
  apiStatus: false,
};
export const fetchAssetName = (data) => ({
  type: actionType.GET_ASSET_NAME,
  payload: data,
});
export const GetAssetsList = (data) => ({
  type: actionType.GET_ASSETS_LIST,
  payload: data,
});

export const APIStart = (data) => ({
  type: actionType.ASSETS_API_START,
  payload: data,
});
export const getSelectedAsset = (data) => ({
  type: actionType.GET_SELECTED_ASSETS_LIST,
  payload: data,
});
export const getSelectedAssetSubCategory = (data) => ({
  type: actionType.GET_SELECTED_ASSETS_SUB_CATEGORY,
  payload: data,
});

export const assetCreate = (payload) => ({
  type: actionType.IS_ASSET_CREATE,
  payload,
});
export const assetList = (payload) => ({
  type: actionType.IS_ASSET_LIST,
  payload,
});

export const assetEdit = (payload) => ({
  type: actionType.IS_ASSET_EDIT,
  payload,
});

export const doUpdateAssetPic = (values) => async (dispatch) => {
  initialState.loading = true;
  dispatch(APIStart(initialState));
  ApiGateWay.SaveData(apiInterface + "/StoreInfo/uploadimages", values)
    .then((result) => {
      console.log(result, "result");
      initialState.loading = false;
      dispatch(APIStart(initialState));
    })
    .catch((e) => {
      initialState.loading = false;
      dispatch(APIStart(initialState));
    });
};

export const getAssetName = (value) => async (dispatch) => {
  const jsonData = Cookie.get("currentUser");
  let decompressedData = LZString.decompressFromBase64(jsonData);
  decompressedData =
    decompressedData == "\x00\x00\x00" ? jsonData : decompressedData;
  const user = JSON.parse(decompressedData);
  const data = {
    store_id: value,
  };
  ApiGateWay.PostCall1(apiInterface + "/AssetInfo/getassetname", data)
    .then((result) => {
      console.log(result, "getassetname");
      initialState.loading = false;
      dispatch(fetchAssetName(result[1]?.Table2));
    })
    .catch((e) => {
      initialState.apiStatus = false;
      initialState.loading = false;
      initialState.modalOpen = true;
      initialState.message =
        "Something went wrong please try again after sometime";
      dispatch(APIStart(initialState));
    });
};
export const doGetAssetsList = () => async (dispatch) => {
  const jsonData = Cookie.get("currentUser");
  let decompressedData = LZString.decompressFromBase64(jsonData);
  decompressedData =
    decompressedData == "\x00\x00\x00" ? jsonData : decompressedData;
  const user = JSON.parse(decompressedData);
  const data = {
    fedid: user["userId"],
  };
  initialState.loading = true;
  dispatch(APIStart(initialState));
  ApiGateWay.SaveData(apiInterface + "/AssetInfo/loadallassetsinfo", data)
    .then((result) => {
      initialState.loading = false;
      if (result[0]?.Table1[0]?.status_code == "000") {
        initialState.message = result[0]?.Table1[2]?.status_msg;

        const LotSet = result[1].Table2;
        const MainCategory = result[2].Table3;
        const SubCategory = result[3].Table4;
        const CapacityType = result[4].Table5;
        const AssetsTypeList = result[5].Table6;
        const PhaseInPhaseOut = result[6].Table7;
        const installatioMethodList = result[7].Table8;
        const FireRatingList = result[8].Table9;
        const StaticPresureList = result[9].Table10;
        const DoorOpeningList = result[10].Table11;
        const PanicBarList = result[11].Table12;
        const DoorTypeList = result[12].Table13;
        const ErthingStripeList = result[13].Table14;
        const StoreList = result[14].Table15;
        const AssetsList = result[15].Table16;
        const VendorList = result[16].Table17;
        const AllowAssets = result[17].Table18;
        AssetsList.forEach((element) => {
          element.status = element.active == 1 ? "Active" : "InActive";
        });
        const data = {
          LotSet,
          MainCategory,
          SubCategory,
          CapacityType,
          AssetsTypeList,
          PhaseInPhaseOut,
          installatioMethodList,
          FireRatingList,
          StaticPresureList,
          DoorOpeningList,
          PanicBarList,
          DoorTypeList,
          ErthingStripeList,
          StoreList,
          AssetsList,
          VendorList,
          AllowAssets,
        };
        initialState.apiStatus = true;
        dispatch(APIStart(initialState));
        dispatch(GetAssetsList(data));
        dispatch(getSelectedAsset(AssetsList[0]));
      } else {
        initialState.apiStatus = false;
        initialState.loading = false;
        initialState.modalOpen = true;
        initialState.message = result[1]?.Table1[2]?.status_msg;
        dispatch(APIStart(initialState));
      }
    })
    .catch((e) => {
      initialState.apiStatus = false;
      initialState.loading = false;
      initialState.modalOpen = true;
      initialState.message =
        "Something went wrong please try again after sometime";
      dispatch(APIStart(initialState));
    });
};

export const SaveAssetDetails = (values) => async (dispatch) => {
  initialState.loading = true;
  dispatch(APIStart(initialState));
  ApiGateWay.newSimplePost(apiInterface4 + "/api/saveAsset", values)
    .then((result) => {
      if (!!result.errorMessage) {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.errorMessage,
          dispatch,
          APIStart,
          initialState
        );
      } else {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.status,
          dispatch,
          APIStart,
          initialState
        );
      }
    })
    .catch((e) => {
      ApiGateWay.updateStateForApi(
        false,
        true,
        false,
        e.error,
        dispatch,
        APIStart,
        initialState
      );
    });
};

export const UpdateAssetDetails = (values) => async (dispatch) => {
  initialState.loading = true;
  dispatch(APIStart(initialState));
  ApiGateWay.newSimplePost(apiInterface4 + "/api/updateAsset", values)
    .then((result) => {
      if (!!result.errorMessage) {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.errorMessage,
          dispatch,
          APIStart,
          initialState
        );
      } else {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.status,
          dispatch,
          APIStart,
          initialState
        );
      }
    })
    .catch((e) => {
      ApiGateWay.updateStateForApi(
        false,
        true,
        false,
        e.error,
        dispatch,
        APIStart,
        initialState
      );
    });
};

export const DeleteAssetDetails = (values) => async (dispatch) => {
  initialState.loading = true;
  dispatch(APIStart(initialState));
  ApiGateWay.SimpleDelete(
    apiInterface4 +
      "/api/deleteAsset?" +
      "storeId=" +
      values.storeId +
      "&assetId=" +
      values.assetId
  )
    .then((result) => {
      if (!!result.errorMessage) {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.errorMessage,
          dispatch,
          APIStart,
          initialState
        );
      } else {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.status,
          dispatch,
          APIStart,
          initialState
        );
      }
    })
    .catch((e) => {
      ApiGateWay.updateStateForApi(
        false,
        true,
        false,
        e.error,
        dispatch,
        APIStart,
        initialState
      );
    });
};

export const checkFormIsEmpty = (form, skip) => {
  for (const [key, value] of Object.entries(form)) {
    if (Array.isArray(skip) && skip.includes(key)) continue;
    if (value === "") {
      return true;
    }
  }
  return false; // no empty fields found
};

export const checkIfEmpty = (field, count) => {
  if (field == "" && count === 1) return true;
  return false;
};

export const _doChangeStep = (stepFormList, stepCount) => {
  let TempArray = [];
  stepFormList.forEach((element) => {
    if (stepCount > element.Index) {
      element.Style = "completed";
    } else if (stepCount === element.Index) {
      element.Style = "inprogress";
    } else {
      element.Style = "";
    }
    TempArray.push(element);
  });

  return TempArray;
};

export const _doNextAction = (
  setSubmit,
  store,
  subCategory,
  stepCount,
  setStepCount
) => {
  setSubmit(true);
  if (checkIfEmpty(store, stepCount)) return;
  if (checkIfEmpty(subCategory, stepCount)) return;
  setSubmit(false);
  setStepCount((stepCount) => stepCount + 1);
};

export const doSubmit = (
  setSubmit,
  addForm,
  subCategory,
  stepCount,
  SaveAssetDetails,
  dispatch
) => {
  setSubmit(true);
  if (checkIfEmpty(addForm.store, stepCount)) return;
  if (checkIfEmpty(subCategory, stepCount)) return;
  const requestData = {
    ...addForm,
    subCategory: Number(subCategory),
    active: addForm.active ? 1 : 0,
    vendor: Number(addForm?.vendor),
    store: Number(addForm?.store),
    assetName: addForm.assetName?.trim(),
  };
  if (checkFormIsEmpty(requestData, ["comments"])) return; //if any fields empty return
  dispatch(SaveAssetDetails(requestData));
};

export function retainCursorOnInputChange(
  e,
  setForm,
  form,
  onCursorPositionChange,
  fieldName
) {
  const cursorPosition = e.target.selectionStart;
  setForm({
    ...form,
    [fieldName]: e.target.value.replace(/[^\w\s]/gi, "").toUpperCase(),
  });
  onCursorPositionChange(cursorPosition);
}
